// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"8ab9c529","171":"75975d5e","443":"e7e425cc","480":"54ab5148","895":"3b4bcd31"}[chunkId] + ".chunk.js";
};